export const projects = [
  {
    title: "React StarShip",
    subtitle: "JavaScript Stack",
    description:
      "Demo Application Built with React, Node.js and MongoDB.  Available to register and look around and start imagining what is possible.",
    image: "./project-1.png",
    link: "http://178.62.84.58:3005/about",
  },
  {
    title: "Node.js Restful API - Movies App",
    subtitle: "Node.js and MongoDB",
    description:
      "Demo Restful API built with Node.js and MongoDB. Available end points to access and check out to see what is possbile.",
    image: "./project-2.png",
    link: "http://178.62.84.58:5005/api/products",
  },
  {
    title: "Shell Scripting",
    subtitle: "Bash Linuxing and Windows shell scripting",
    description:
      "Shell scripting for automated, maintenace and administration purposes of applications and operating systems.",
    image: "./project-3.png",
    link: "./backup.txt",
  },
  {
    title: "Application Components",
    subtitle: "Components Documentation",
    description: "Application Components Description",
    image: "./project-7.png",
    link: "https://joplin.daconsulting.co.za/shares/zR5NjPJW9auNrWf77ojcRM",
  },
  {
    title: "API Documentation",
    subtitle: "Postman Documentation",
    description:
      "Postman used to document API endpoints with example data input and responses for easy reference and integration.",
    image: "./project-4.png",
    link: "https://documenter.getpostman.com/view/24431345/2s93Joy68j",
  },

  {
    title: "Node.js RESTApi",
    subtitle: "Completed Node.js",
    description:
      "The Javascript application used Node modules, async code, CRUD operations, MongoDB, authorisations using JWT, error handling, config, unit and integration tests, and deployed in Docker.",
    image: "./project-5.png",
    link: "./project-5.pdf",
  },
  {
    title: "Mastering React",
    subtitle: "Frontend Application fast, dynamic and stands-out.",
    description:
      "The React App used modern JS, reusable components, tables/lists with pagination, sorting and searching, form validation, React Router for routing, Axios for HTTP services, authentication and error handling, function components/hooks, React Context for data sharing, and deployment in Docker.",
    image: "./project-6.png",
    link: "./project-6.pdf",
  },
];

export const testimonials = [
  {
    quote:
      "Node.js course offered by Programming with Mosh over 10 Million students",
    image: "./certificate-1.png",
    name: "Complete Node.js Course",
    company: "Code with Mosh",
    link: "./certificate-1.pdf",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React/Redux/Material UI",
  "Node.js",
  "MongoDB",
  "Shell Scripting",
  "SQL",
  "Postman",
  "Restful API's",
  "Payments Gateway",
  "ClickUp Integration",
  "Github Integration",
  "Flow Gear Integration",
  "Whatsapp Integration",
  "Google Mail Integration",
  "Outlook Mail Integration",
  "AI Integration",
  "Docker Containers",
  "Linux VM's",
  "Cloud Services",
];

export const mail = [
  {
    smtpHost: "localhost",
    smtpPort: 25,
  },
];



// WEBPACK FOOTER //
// ./src/data.js